import { useEffect, useState } from "react";
import { Brain, Trash2, ArrowRightLeft, Boxes } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Configuración → Mapeos: lo que el importador recuerda de lotes (traslados por referencia y desgloses ×N). */
export default function LoteMemoriasPanel() {
  const [d, setD] = useState(null);
  const load = () => api.get("/productos/_/lote-memorias").then((r) => setD(r.data)).catch(() => setD({ traslados: [], desgloses: [] }));
  useEffect(() => { load(); }, []);
  const borrar = async (tipo, id, label) => {
    if (!window.confirm(`¿Dejar de recordar "${label}"? Los próximos contenedores entrarán sin esta regla.`)) return;
    try { await api.delete(`/productos/_/lote-memorias/${tipo}/${id}`); toast.success("Memoria borrada"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "No se pudo borrar"); }
  };
  if (!d) return null;
  const vacio = !d.traslados.length && !d.desgloses.length;
  return (
    <div className="mt-8 rounded-2xl border border-border bg-card p-4" data-testid="lote-memorias-panel">
      <div className="flex items-center gap-2 mb-1"><Brain className="w-4 h-4 text-primary" /><h2 className="font-semibold">Memoria de lotes para próximos contenedores</h2></div>
      <p className="text-xs text-muted-foreground mb-3">Reglas que marcaste con "Recordar para próximos contenedores" al trasladar o desglosar un lote. El importador las aplica solo; bórralas si ya no aplican.</p>
      {vacio && <div className="text-sm text-muted-foreground py-4 text-center">Todavía no hay reglas recordadas.</div>}
      {d.traslados.length > 0 && (
        <div className="mb-3">
          <div className="text-[10px] font-bold uppercase tracking-[0.14em] text-muted-foreground mb-1 flex items-center gap-1"><ArrowRightLeft className="w-3 h-3" /> Traslados por referencia</div>
          <div className="divide-y divide-border rounded-lg border border-border">
            {d.traslados.map((m) => (
              <div key={m.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`memoria-traslado-${m.id}`}>
                <div className="flex-1 min-w-0"><span className="font-mono text-xs font-bold">{m.clave}</span> <span className="text-muted-foreground">de</span> <span className="truncate">{m.producto_origen_nombre}</span> <span className="text-muted-foreground">→</span> <b>{m.producto_destino_nombre}</b>
                  <div className="text-[11px] text-muted-foreground">{m.usos || 0} usos · {m.por || ""}</div></div>
                <button type="button" onClick={() => borrar("traslado", m.id, m.clave)} className="p-1.5 rounded-md text-rose-600 hover:bg-rose-50" title="Dejar de recordar" data-testid={`memoria-traslado-borrar-${m.id}`}><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        </div>
      )}
      {d.desgloses.length > 0 && (
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.14em] text-muted-foreground mb-1 flex items-center gap-1"><Boxes className="w-3 h-3" /> Desglose automático ×N al importar</div>
          <div className="divide-y divide-border rounded-lg border border-border">
            {d.desgloses.map((p) => (
              <div key={p.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`memoria-desglose-${p.id}`}>
                <div className="flex-1 min-w-0 truncate">{p.nombre} <span className="text-muted-foreground text-xs">{p.sku || p.codigo}</span></div>
                <span className="font-mono text-xs font-bold text-violet-700">×{p.factor_empaque}</span>
                <button type="button" onClick={() => borrar("desglose", p.id, `${p.nombre} ×${p.factor_empaque}`)} className="p-1.5 rounded-md text-rose-600 hover:bg-rose-50" title="Dejar de recordar" data-testid={`memoria-desglose-borrar-${p.id}`}><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
